import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  EmployeeHeader,
  PageHeader,
  DropdownMenu,
  InfoText,
  InfoTextTwo,
  TimeSheet,
  Divider,
  Drawer,
  Modal,
  StatusTags,
  showToast,
  DocumentsList,
  DevNote,
  useFormHandler,
  FormFieldSet,
  Backdrop,
  LogoLoader,
  AuditHistory,
  TableAdv,
} from "../../../../../components";
import {
  dateFormator,
  getEmployeeId,
  mapTableRows,
} from "../../../../../utils";
import { activityTableData } from "../../../../../assets/data/candidatesData";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearPlacementsData,
  getPlacementByUiidStart,
} from "../../../../../redux/slices/placements/placementsSlice";
import { getEmployeeName } from "../../../../../utils/getDisplays";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import weekOfYear from "dayjs/plugin/weekOfYear";
import isoWeek from "dayjs/plugin/isoWeek";
import {
  clearEmployeeData,
  getEmployeeByUiidStart,
} from "../../../../../redux/slices/employee/employeeSlice";
import { useLoginUser } from "../../../../../hooks/useLoginUser";
import {
  getTimesheetOneStart,
  updateTimesheetStart,
} from "../../../../../redux/slices/timesheets/timsheetSlice";
import { exactUTCDate } from "../../../../../utils/dateFormator";
import { uploadStart } from "../../../../../redux/slices/universal/fileUploadSlice";
import TimesheetData from "../../../ComponentsList/List/PdfGeneratorList/Timesheet/TimesheetData";
import TimesheetHeader from "./TimesheetPdfComponents/TimesheetHeader";
import TimesheetContent from "./TimesheetPdfComponents/TimesheetContent";
import TimesheetTableHeader from "../../../ComponentsList/List/PdfGeneratorList/Timesheet/TimesheetTableHeader";
import TimesheetFooter from "./TimesheetPdfComponents/TimesheetFooter";
import generatePdf from "../../../../../components/PdfGenerator/generatePdf";
import { EmployeeStatus } from "../../../../../assets/data/enumData";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);

export const handleTimesheetDownload = async (data) => {
  await generatePdf({
    initialLayout: "portrait",
    items: data.timesheetData,
    // Render 7-day rows: pass the full items array and current index
    rowRenderer: (_, index) => TimesheetData(data.timesheetData, index),
    header: () => <TimesheetHeader data={data} />,
    headerTwo: () => <TimesheetHeader data={data} type="sub" />,
    contentTop: () => <TimesheetContent data={data} type="top" />,
    contentBottom: () => <TimesheetContent data={data} type="bottom" />,
    tableHeader: () => <TimesheetTableHeader />,
    footer: (page) => <TimesheetFooter data={data} {...page} />,
    footerTwo: (page) => <TimesheetFooter data={data} type="sub" {...page} />,
    // footerTwo: (page) => (
    //   <TimesheetFooter data={data} type="sub" {...page} />
    // ),
    backgroundLogo: data?.company?.companyLogo,
    // fileName: `Timesheet-001`,
    fileName: `Timesheet-(${data?.employee?.id || ""})-${data?.timesheetPeriod?.from && data?.timesheetPeriod?.to ? dayjs(data?.timesheetPeriod?.from).format("MM/DD/YYYY") + "-" + dayjs(data?.timesheetPeriod?.to).format("MM/DD/YYYY") : ""}`,
  });
};
export const getShortBusinessName = (name) => {
  if (!name) return "";
  const firstWord = name.trim().split(/\s+/)[0];
  const trimmed = firstWord.slice(0, 3);
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
};
const timeToDecimal = (timeStr) => {
  if (!timeStr) return 0;
  const [hours, minutes] = timeStr.split(":").map(Number);
  return Number((hours + minutes / 60).toFixed(2));
};
const TimesheetDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [auditHistory, setAuditHistory] = useState(false);
  //selectors
  const {
    uiid: placementId,
    timesheetId: timesheetId,
    employeeId: currentEmployeeId,
  } = location?.state || {};
  const [sendMailModal, setSendMailModal] = useState(false);

  const { data: currentPlacementData = [] } =
    useSelector((state) => state.placement.placements) || [];
  const timesheetDataFromDb =
    useSelector((state) => state.timesheet.currentTimesheet.details) || [];
  console.log({ currentPlacementData });
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  // const userApproval = timesheetDataFromDb?.auditHistory
  //   ?.slice()
  //   ?.reverse()
  //   ?.find(
  //     (item) =>
  //       item?.updatedBy?.uiid === loginUserData?.employeeId &&
  //       item?.status === 3
  //   );
  const userApproval = timesheetDataFromDb?.auditHistory
    ?.slice()
    ?.reverse()
    ?.find((item) => item?.updatedBy?.uiid === loginUserUiid);
  const isUserApproved = !!userApproval?.status === 3 || false;
  // const userRejected = timesheetDataFromDb?.auditHistory
  //   ?.slice()
  //   ?.reverse()
  //   ?.find(
  //     (item) =>
  //       item?.updatedBy?.uiid === loginUserData?.employeeId &&
  //       item?.status === 4
  //   );
  const userRejected = timesheetDataFromDb?.auditHistory
    ?.slice()
    ?.reverse()
    ?.find((item) => item?.updatedBy?.uiid === loginUserUiid);

  const isUserRejected = !!userRejected?.status === 4 || false;

  //states
  const [isEditable, setIsEditable] = useState(false);
  const [arrayOfApprovers, setArrayOfApprovers] = useState([]);
  const [clientDetails, setClientDetails] = useState(false);
  const [timesheetData, setTimesheetData] = useState([]);
  const [employeeManagers, setEmployeeManagers] = useState({
    finance: "",
    hr: "",
    reportingManager: "",
  });
  const [datesOfPlacement, setDatesOfPlacement] = useState({
    startDate: "",
    endDate: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [hasInvoice, setHasInvoice] = useState(false);
  const [allowEditing, setAllowEditing] = useState(true);
  const [editConfirmation, setEditConfirmation] = useState(false);

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        attachments: [],
      },
      {
        attachments: {
          type: "file",
          // required: true,
        },
      },
    );

  const employeeId = useMemo(
    () =>
      currentPlacementData?.employeeId?.uiid
        ? getEmployeeId(
            currentPlacementData?.employeeId?.uiid,
            currentPlacementData?.employeeId?.employmentType,
          )
        : undefined,
    [currentPlacementData],
  );
  useEffect(() => {
    dispatch(
      getEmployeeByUiidStart({
        uiid: currentEmployeeId,
        tab: "overview",
        ret: "uiid profilePhotoUrl firstName middleName lastName jobTitle status employmentType email mobile ssn dob bloodType employmentType",
      }),
    );
    return () => {
      // dispatch(clearEmployeeData());
    };
  }, [currentEmployeeId]);

  useEffect(() => {
    if (placementId) {
      dispatch(
        getPlacementByUiidStart({
          fil: {
            uiid: { type: "NONE", value: placementId },
          },
          // ref: "Client Employee Approver",
          ref: "Client EmpWithApprover EmpWithDelegator Approver",
          // incl: "businessName",
        }),
      );
    }

    return () => {
      dispatch(clearPlacementsData());
    };
  }, [placementId]);
  //working
  // useEffect(() => {
  //   const fetchApprovers = async () => {
  //     const approvers = currentPlacementData?.timesheetDetails?.approvers || [];
  //     const approversPromise = approvers.map((item) =>
  //       getEmployeeName(item.id)
  //     );
  //     let approversName = await Promise.all(approversPromise);
  //     setArrayOfApprovers(approversName);
  //   };
  //   const fetchManagers = async () => {
  //     const managersFromData = currentPlacementData?.employeeId?.managers || {};
  //     const financeManager = managersFromData.finance
  //       ? await getEmployeeName(managersFromData.finance)
  //       : "";
  //     const hrManager = managersFromData.HR
  //       ? await getEmployeeName(managersFromData.HR)
  //       : "";
  //     const reportingManager = managersFromData.reportingManager
  //       ? await getEmployeeName(managersFromData.reportingManager)
  //       : "";
  //     setEmployeeManagers((prev) => ({
  //       ...prev,
  //       finance: financeManager,
  //       hr: hrManager,
  //       reportingManager: reportingManager,
  //     }));
  //   };
  //   if (currentPlacementData?.employeeId?.managers) {
  //     fetchManagers();
  //   }
  //   if (currentPlacementData?.timesheetDetails?.approvers?.length > 0) {
  //     fetchApprovers();
  //   }
  //   if (currentPlacementData?.jobInfo?.startDate) {
  //     setDatesOfPlacement((prevDates) => ({
  //       ...prevDates,
  //       startDate: currentPlacementData?.jobInfo?.startDate,
  //       endDate: currentPlacementData?.jobInfo?.endDate,
  //     }));
  //   }
  // }, [currentPlacementData]);

  // console.log("currentPlacementData", currentPlacementData);
  // console.log("managers", employeeManagers);
  // console.log("rendering TimesheetDetails");
  useEffect(() => {
    if (!currentPlacementData?.uiid) return;

    const {
      timesheetDetails = {},
      employeeId = {},
      jobInfo = {},
    } = currentPlacementData;

    const fetchAll = async () => {
      const approvers = timesheetDetails.approvers || [];
      const managers = employeeId.managers || {};

      const approverNames = await Promise.all(
        approvers.map(async (approver) => {
          const name = await getEmployeeName(approver?.id?.[0]?.uiid);
          return `${name}:${approver.id?.[0]?.userId}`;
        }),
      );

      const [finance, hr, reportingManager] = await Promise.all([
        managers.finance ? getEmployeeName(managers.finance) : "",
        managers.HR ? getEmployeeName(managers.HR) : "",
        managers.reportingManager
          ? getEmployeeName(managers.reportingManager)
          : "",
      ]);

      const newManagerObj = { finance, hr, reportingManager };
      const newDateObj = {
        startDate: jobInfo.startDate || "",
        endDate: jobInfo.endDate || "",
      };

      const isSameManager =
        JSON.stringify(employeeManagers) === JSON.stringify(newManagerObj);
      const isSameDate =
        JSON.stringify(datesOfPlacement) === JSON.stringify(newDateObj);

      if (!isSameManager) setEmployeeManagers(newManagerObj);
      if (!isSameDate) setDatesOfPlacement(newDateObj);
      if (approverNames.length) setArrayOfApprovers(approverNames);
    };

    fetchAll();
  }, [currentPlacementData?.uiid]);

  const data = [];
  const tableData = activityTableData;
  const columns = [
    {
      key: "dateAndTime",
      label: "Date & Time",
      render: (row) => dateFormator(row.dateAndTime, "datetime"),
    },

    {
      key: "record",
      label: "Record",
    },

    {
      key: "description",
      label: "Description",
      render: (row) => dateFormator(row.description, "month-day-year"),
    },
    {
      key: "updatedBy",
      label: "Updated By",
    },
  ];
  const emailcolumns = [
    {
      key: "status",
      label: "Status",
    },

    {
      key: "emailSubject",
      label: "Email Subject",
    },
    {
      key: "recipient",
      label: "Recipient",
    },
    {
      key: "dateAndTime",
      label: "Date & Time",
      render: (row) => dateFormator(row.appliedOn, "month-day-year"),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);
  const emailRows = mapTableRows(data, emailcolumns);
  const handleExposeState = (state) => {
    setTimesheetData(state);
  };
  const handleSave = (statusType) => {
    // actual logic to who can approve
    const canApprove = currentPlacementData?.timesheetDetails?.approvers?.some(
      (approver) => approver.id?.[0]?.userId === loginUserUiid,
    );
    const isApprovalDelegator =
      currentPlacementData?.employeeId?.approvalFlow?.approvers?.some(
        (approver) => approver?.userId === loginUserUiid,
      ) ?? false;
    console.log({ canApprove, isApprovalDelegator });
    if (!canApprove && !isApprovalDelegator) {
      showToast("You are not authorized", "error", 3000);
      return;
    }
    //to keep last approvers status as actual timesheet status
    console.log(
      "last approver",
      currentPlacementData?.timesheetDetails?.approvers?.slice(-1)[0]?.id?.[0],
    );
    const lastApprover =
      currentPlacementData?.timesheetDetails?.approvers?.slice(-1)[0]?.id?.[0]
        ?.userId;
    const isUserlastApprover = lastApprover === loginUserUiid;
    try {
      let createdPayload;
      if (timesheetDataFromDb?.uiid) {
        //for update payload
        createdPayload = [
          {
            type: "SET",
            value: {
              _skipFlatten: ["dailyEntries"],
              //to keep last approvers status as actual timesheet status
              ...(isUserlastApprover && { status: statusType }),
              dailyEntries: timesheetData?.map((item) => ({
                // date: dayjs(item.payClassification, "YYYYMMDD").toISOString(),
                ...timesheetDataFromDb?.dailyEntries?.find(
                  (entry) =>
                    entry.date ===
                    Number(
                      dayjs
                        .utc(item.payClassification, "YYYYMMDD")
                        .format("YYYYMMDD"),
                    ),
                ),
                date: dayjs
                  .utc(item.payClassification, "YYYYMMDD")
                  .format("YYYYMMDD"),
                st: timeToDecimal(item.standardTime),
                th: timeToDecimal(item.standardTime),
                tbh: timeToDecimal(item.standardTime),
                // as per new changes the th and tbh is same as st as per update on 29-5-2025
                // th: timeToDecimal(item.totalHours),
                // tbh: timeToDecimal(item.totalBillableHours),
              })),
              amounts: {
                // total:
                //   timesheetData?.reduce(
                //     (acc, item) => acc + timeToDecimal(item.standardTime),
                //     0
                //   ) *
                //   (currentPlacementData?.payments[
                //     currentPlacementData?.payments.length - 1
                //   ]?.payRate?.payRatePerHour || 0),
                total:
                  currentPlacementData?.payments[
                    currentPlacementData?.payments.length - 1
                  ]?.payRate?.payType === 1
                    ? timesheetData?.reduce(
                        (acc, item) => acc + timeToDecimal(item.standardTime),
                        0,
                      ) *
                      (currentPlacementData?.payments[
                        currentPlacementData?.payments.length - 1
                      ]?.payRate?.payRatePerHour || 0)
                    : currentPlacementData?.payments[
                        currentPlacementData?.payments.length - 1
                      ]?.payRate?.payRatePerHour,
              },
            },
          },
          {
            type: "PUSH",
            value: {
              ...(statusType !== 1 && {
                auditHistory: [
                  {
                    timestamp: new Date(),
                    status: statusType,
                    st: timesheetData?.reduce(
                      (acc, item) => acc + timeToDecimal(item.standardTime),
                      0,
                    ),
                    tbh: timesheetData?.reduce(
                      (acc, item) =>
                        acc + timeToDecimal(item.totalBillableHours),
                      0,
                    ),
                    // updatedBy: loginUserData?.employeeId, // plug in your user identifier
                    updatedBy: loginUserUiid, // plug in your user identifier
                  },
                ],
              }),
            },
          },
        ];
      }
      // return;
      if (timesheetDataFromDb?.uiid) {
        // showToast(`hasInvoice ${hasInvoice} new version of invoice genereted`);
        //updating existing timesheet
        dispatch(
          updateTimesheetStart({
            coll: "Timesheet",
            uiid: timesheetDataFromDb.uiid,
            payload: createdPayload,
            ...(hasInvoice && { preActions: ["DuplicateInvoice"] }),
            onSuccess: async (resData) => {
              dispatch(
                getTimesheetOneStart({
                  ref: "UpdatedBy Invoice Employee Client",
                  filters: {
                    uiid: {
                      type: "NONE",
                      value: resData?.data?.doc?.uiid,
                    },
                  },
                }),
              );
            },
          }),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  // const getShortBusinessName = (name) => {
  //   if (!name) return "";
  //   const firstWord = name.trim().split(/\s+/)[0];
  //   const trimmed = firstWord.slice(0, 3);
  //   return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  // };
  const [approverWithStatus, setAppoverWithStatus] = useState([]);
  useEffect(() => {
    if (arrayOfApprovers.length) {
      const getActivityOfApprover = (id, type = null) => {
        const TimesheetStatus = {
          1: "Draft",
          2: "Submitted",
          3: "Approved",
          4: "Rejected",
          5: "Job Inactive",
          6: "Invoiced",
        };
        const latestAudit =
          timesheetDataFromDb?.auditHistory
            ?.slice()
            ?.reverse()
            ?.find((item) => item?.updatedBy?.uiid === id) || null;
        return type === "detail"
          ? latestAudit
          : latestAudit
            ? TimesheetStatus[latestAudit.status]
            : "No activity";
      };
      const approversStatus = arrayOfApprovers?.map((item) => {
        return {
          name: item.split(":")[0] || "-",
          status: getActivityOfApprover(Number(item.split(":")[1])),
          details: getActivityOfApprover(Number(item.split(":")[1]), "detail"),
        };
      });
      setAppoverWithStatus(approversStatus);
    }
  }, [arrayOfApprovers, timesheetDataFromDb?.auditHistory]);
  //   const downloadTableAsPDF = async () => {
  //   try {
  //     const { jsPDF } = window.jspdf;
  //     const node = document.getElementById("table-wrapper");

  //     const canvas = await html2canvas(node, {
  //       useCORS: true,
  //       scale: 2,
  //       allowTaint: false,
  //       logging: false,
  //     });

  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     const imgProps = pdf.getImageProperties(imgData);
  //     const pdfWidth = pageWidth;
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  //     let position = (pageHeight - pdfHeight) / 2;
  //     pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight, undefined, undefined, 0);

  //     pdf.save("table.pdf");
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const handleUpload = async () => {
    try {
      if (!timesheetDataFromDb?.uiid) {
        showToast("Something Went Wrong", "error", 3000);
      }
      setIsUploading(true);
      const timesheetId = timesheetDataFromDb?.uiid;
      if (formData?.attachments?.length > 0) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            uiid: timesheetId,
            entity: "timesheets",
            category: "timesheets",
            coll: "Timesheet",
            doc: formData?.attachments,
            addedBy: loginUserUiid,
            onSuccess: async (fileData) => {
              const payload = [
                {
                  type: "PUSH",
                  value: {
                    attachments: fileData.map((file) => file.key),
                  },
                },
              ];
              dispatch(
                updateTimesheetStart({
                  coll: "Timesheet",
                  uiid: timesheetId,
                  payload: payload,
                  onSuccess: async () => {
                    dispatch(
                      getTimesheetOneStart({
                        ref: "UpdatedBy Invoice Employee Client",
                        filters: {
                          uiid: {
                            type: "NONE",
                            value: timesheetId,
                          },
                        },
                      }),
                    );
                  },
                }),
              );
            },
          }),
        );
      } else {
        showToast("Please Upload Timesheet", "warning", 3000);
      }
    } catch (error) {
      showToast("Something Went Wrong While Uploading", "error", 3000);
      console.error("Error in handle Upload Timesheet", error);
    } finally {
      setIsUploading(false);
      setIsUploadOpen(false);
    }
  };
  const handleEdit = () => {
    try {
      if (!editConfirmation) {
        if (timesheetDataFromDb?.invoiceId?.length) {
          setHasInvoice(true);
          setAllowEditing(false);
          setEditConfirmation(false);
          showToast("Invoice already exists", "warning", 3000);
          return;
        }
      }
      if (allowEditing) {
        setIsEditable((prev) => !prev);
      }
    } catch (error) {
      console.error("There was an error", error);
    }
  };

  // const timesheetDownloader = async () => {
  //   try {
  //     setIsUploading(true);
  //     const currentTimesheet = timesheetDataFromDb || {}; // the large object you pasted
  //     console.log({ currentTimesheet });

  //     const data = {
  //       company: {
  //         name: "TekTree LLC",
  //         address: "1106 Drummond Plaza, DE 19711",
  //         contact: "+1 (123) 456-7890",
  //         email: "accounts@tektreeinc.com",
  //         website: "www.tektreeinc.com",
  //         companyLogo: loginUserData?.organizationId?.logo?.company,
  //         additionalInfo: `This Invoice has been Sold & Assigned to Tek Tree LLC Remit payment only to: P.O Box #799, Gloucester, VA - 23061, C/O Chesapeake Bank, Chesapeake Bank`,
  //       },
  //       client: {
  //         name: currentTimesheet?.clientId?.businessName || "",
  //         address: [
  //           currentTimesheet?.clientId?.generalInfo?.locations?.[0]?.address1,
  //           currentTimesheet?.clientId?.generalInfo?.locations?.[0]?.address2,
  //           currentTimesheet?.clientId?.generalInfo?.locations?.[0]?.city,
  //           currentTimesheet?.clientId?.generalInfo?.locations?.[0]?.state,
  //           currentTimesheet?.clientId?.generalInfo?.locations?.[0]?.country,
  //       ]?.filter((item) => item).join(", ") || "",
  //         phone:
  //           currentTimesheet?.clientId?.phone
  //             ?.map((phone) => `${phone?.code || ""} ${phone?.number || ""}`)
  //             ?.join(", ") || "",
  //         email:
  //           currentTimesheet?.clientId?.email
  //             ?.map((email) => email)
  //             ?.join(", ") || "",
  //       },
  //       employee: {
  //         id: getEmployeeId(
  //           currentTimesheet.employeeId.uiid,
  //           currentTimesheet.employeeId.employmentType
  //         ),
  //         status: EmployeeStatus?.find(
  //           (item) => item.value === currentTimesheet.employeeId.employmentType
  //         )?.label,
  //         name:
  //           currentTimesheet.employeeId.firstName +
  //           " " +
  //           currentTimesheet.employeeId.lastName,
  //         designation: currentTimesheet.employeeId.jobTitle,
  //         address:
  //           currentTimesheet.employeeId.location.city +
  //           ", " +
  //           currentTimesheet.employeeId.location.state,
  //         phone: currentTimesheet.employeeId.mobile.primary.number,
  //         email: currentTimesheet.employeeId.email.primary,
  //       },
  //       timesheetPeriod: {
  //         from: currentTimesheet.period.from,
  //         to: currentTimesheet.period.to,
  //       },
  //     };

  //     // Convert currentTimesheet dailyEntries to your UI format
  //     data.timesheetData = currentTimesheet.dailyEntries.map((entry) => {
  //       const dateString = entry.date.toString();
  //       const yyyy = dateString.slice(0, 4);
  //       const mm = dateString.slice(4, 6);
  //       const dd = dateString.slice(6, 8);
  //       const iso = `${yyyy}-${mm}-${dd}T00:00:00.000Z`;

  //       const normalize = (v) => `${String(v).padStart(2, "0")}.00`;

  //       return {
  //         date: iso,
  //         standardTime: normalize(entry.st),
  //         totalBillableHours: normalize(entry.tbh),
  //         totalHours: normalize(entry.th),
  //       };
  //     });

  //     // Compute totals
  //     const sum = (key) => {
  //       let total = 0;
  //       data.timesheetData.forEach((x) => {
  //         total += parseFloat(x[key]);
  //       });
  //       return total.toFixed(2);
  //     };

  //     data.finalStandardTime = sum("standardTime");
  //     data.finalTotalBillableHours = sum("totalBillableHours");
  //     data.finalTotalHours = sum("totalHours");

  //     await handleTimesheetDownload(data);
  //   } catch (error) {
  //     console.error("Error downloading timesheet:", error);
  //   } finally {
  //     setIsUploading(false);
  //   }
  // };
  //
  //
  //
  const timesheetDownloader = async () => {
    try {
      setIsUploading(true);

      const currentTimesheet = timesheetDataFromDb || {};
      console.log({ currentTimesheet });

      const data = {
        company: {
          name: "TekTree LLC",
          address: "1106 Drummond Plaza, DE 19711",
          contact: "+1 (123) 456-7890",
          email: "accounts@tektreeinc.com",
          website: "www.tektreeinc.com",
          companyLogo: loginUserData?.organizationId?.logo?.company,
          additionalInfo: `This Invoice has been Sold & Assigned to Tek Tree LLC Remit payment only to: P.O Box #799, Gloucester, VA - 23061, C/O Chesapeake Bank, Chesapeake Bank`,
        },
        client: {
          name: currentTimesheet?.clientId?.businessName || "",
          address:
            [
              currentTimesheet?.clientId?.generalInfo?.locations?.[0]?.address1,
              currentTimesheet?.clientId?.generalInfo?.locations?.[0]?.address2,
              currentTimesheet?.clientId?.generalInfo?.locations?.[0]?.city,
              currentTimesheet?.clientId?.generalInfo?.locations?.[0]?.state,
              currentTimesheet?.clientId?.generalInfo?.locations?.[0]?.country,
            ]
              ?.filter(Boolean)
              .join(", ") || "",
          phone:
            currentTimesheet?.clientId?.phone
              ?.map((phone) => `${phone?.code || ""} ${phone?.number || ""}`)
              ?.join(", ") || "",
          email:
            currentTimesheet?.clientId?.email
              ?.map((email) => email)
              ?.join(", ") || "",
        },
        employee: {
          id: getEmployeeId(
            currentTimesheet?.employeeId?.uiid,
            currentTimesheet?.employeeId?.employmentType,
          ),
          status: EmployeeStatus?.find(
            (item) =>
              item.value === currentTimesheet?.employeeId?.employmentType,
          )?.label,
          name: `${currentTimesheet?.employeeId?.firstName || ""} ${currentTimesheet?.employeeId?.lastName || ""}`,
          designation: currentTimesheet?.employeeId?.jobTitle || "",
          address: `${currentTimesheet?.employeeId?.location?.city || ""}, ${currentTimesheet?.employeeId?.location?.state || ""}`,
          phone: currentTimesheet?.employeeId?.mobile?.primary?.number || "",
          email: currentTimesheet?.employeeId?.email?.primary || "",
        },
        timesheetPeriod: {
          from: currentTimesheet?.period?.from,
          to: currentTimesheet?.period?.to,
        },
      };

      // ---------- helpers ----------
      const toHHMM = (num) => {
        if (num == null || num === "") return "00:00";
        const hours = Math.floor(Number(num));
        const minutes = (Number(num) % 1) * 60;
        return `${String(hours).padStart(2, "0")}:${String(
          Math.round(minutes),
        ).padStart(2, "0")}`;
      };

      const toHHdotMM = (num) => {
        const [h, m] = toHHMM(num).split(":");
        return `${h}.${m}`;
      };

      const parseDateRange = () => {
        const from = new Date(data.timesheetPeriod.from);
        const to = new Date(data.timesheetPeriod.to);

        const start = new Date(from);
        const startDay = start.getDay(); // 0=Sun
        const diffToMonday = startDay === 0 ? -6 : 1 - startDay;
        start.setDate(start.getDate() + diffToMonday);

        const end = new Date(to);
        const endDay = end.getDay();
        const diffToSunday = endDay === 0 ? 0 : 7 - endDay;
        end.setDate(end.getDate() + diffToSunday);

        return { start, end, from, to };
      };

      const { start, end, from, to } = parseDateRange();

      const timesheetData = [];

      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const date = new Date(d);
        const isoDate = date.toISOString();
        const dayOfWeek = date.getDay();

        let standardTime = "";
        let totalBillableHours = "";
        let totalHours = "";

        if (date >= from && date <= to) {
          const ymd = date.toISOString().split("T")[0].replace(/-/g, "");
          const entry = currentTimesheet.dailyEntries?.find(
            (e) => String(e.date) === ymd,
          );

          if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            const st = entry?.st ?? 8;
            const tbh = entry?.tbh ?? st;
            const th = entry?.th ?? st;
            standardTime = toHHdotMM(st);
            totalBillableHours = toHHdotMM(tbh);
            totalHours = toHHdotMM(th);
          } else {
            standardTime = "00.00";
            totalBillableHours = "00.00";
            totalHours = "00.00";
          }
        } else {
          standardTime = null;
          totalBillableHours = null;
          totalHours = null;
        }

        timesheetData.push({
          date: isoDate,
          standardTime,
          totalBillableHours,
          totalHours,
        });
      }

      data.timesheetData = timesheetData;

      // ---------- totals ----------
      const totalValue = data.timesheetData.reduce(
        (acc, item) => {
          const addTime = (accKey, timeStr) => {
            if (!timeStr) return;
            const [hours, minutes] = timeStr.split(".").map(Number);
            accKey.hours += hours;
            accKey.minutes += minutes;
            if (accKey.minutes >= 60) {
              accKey.hours += Math.floor(accKey.minutes / 60);
              accKey.minutes %= 60;
            }
          };

          addTime(acc.standardTime, item.standardTime);
          addTime(acc.totalBillableHours, item.totalBillableHours);
          addTime(acc.totalHours, item.totalHours);

          return acc;
        },
        {
          standardTime: { hours: 0, minutes: 0 },
          totalBillableHours: { hours: 0, minutes: 0 },
          totalHours: { hours: 0, minutes: 0 },
        },
      );

      const toDecimal = ({ hours, minutes }) =>
        Number((hours + minutes / 60).toFixed(2));

      data.finalStandardTime = toDecimal(totalValue.standardTime).toFixed(2);
      data.finalTotalBillableHours = toDecimal(
        totalValue.totalBillableHours,
      ).toFixed(2);
      data.finalTotalHours = toDecimal(totalValue.totalHours).toFixed(2);

      await handleTimesheetDownload(data);
    } catch (error) {
      console.error("Error downloading timesheet:", error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div>
      <div>
        <DevNote>
          <h5>{`Does have any  invoice ${hasInvoice ? "true" : "false"}`}</h5>
          <h5>{`Timesheet ID :${timesheetDataFromDb?.uiid}`}</h5>
          <h5>{`Timesheet Status :${timesheetDataFromDb?.status}`}</h5>
        </DevNote>
        <PageHeader
          Section={<EmployeeHeader full dropdownShow={false} />}
          RightSection={
            <div className="flex gap-2 justify-end items-center">
              <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                type="link"
                onClick={() => window.history.back()}
              />
              <Button
                color="primary"
                size="sm"
                title={"Audit History"}
                onClick={() => setAuditHistory(true)}
              />
              {[3,6].includes(timesheetDataFromDb?.status) ? "" : (<>
              <Button
                color="primary"
                size="sm"
                title={isUserApproved ? "Approved" : "Approve"}
                // disabled={isUserApproved || timesheetDataFromDb?.status === 6}
                disabled={isUserApproved}
                onClick={() => handleSave(3)}
              />
              <Button
                color="primary"
                size="sm"
                // title={isUserRejected || isUserApproved ? "Rejected" : "Reject"}
                // disabled={isUserRejected || isUserApproved}
                title={isUserApproved || isUserRejected ? "Rejected" : "Reject"}
                disabled={
                  isUserApproved || isUserRejected
                  // ||
                  // timesheetDataFromDb?.status === 6
                }
                onClick={() => handleSave(4)}
              />
              </>)
              }
              {timesheetDataFromDb?.status === 6 && <>
                <Button
                  color="primary"
                  size="sm"
                  title={"Update Invoice"}
                  onClick={() => handleSave(6)}
                />
              </>
              }
              <Button
                color="black"
                size="sm"
                title={"Edit"}
                onClick={handleEdit}
              />
              <DropdownMenu
                MenuSection={
                  <div className="p-1 ">
                    <Button
                      color="dark"
                      title={"Mail Sent Log"}
                      variant="text"
                      size="sm"
                      className="w-full text-left"
                      onClick={() => setSendMailModal(true)}
                    />
                    <Button
                      color="dark"
                      title={"Download PDF"}
                      variant="text"
                      size="sm"
                      className="w-full text-left"
                      onClick={timesheetDownloader}
                    />
                  </div>
                }
              >
                <Button
                  color="primary"
                  size="sm"
                  title={"More Actions"}
                  icon="keyboard_arrow_down"
                  iconPosition="after"
                />
              </DropdownMenu>
            </div>
          }
        />
      </div>
      <div className="bg-neutrals-50 my-3 rounded-sm px-5 py-3 ">
        <div className="grid grid-cols-3 gap-5">
          <div className="flex gap-2 ">
            <InfoText
              textWrap
              title={"Job"}
              size="sm"
              value={
                <div>
                  {currentPlacementData?.jobInfo?.jobTitle}
                  <br />
                  {`at ${
                    currentPlacementData?.jobInfo?.billClient?.businessName
                  } ${getShortBusinessName(
                    currentPlacementData?.jobInfo?.billClient?.businessName,
                  )}-${currentPlacementData?.uiid}`}
                  <br />
                </div>
              }
            />
          </div>
          <div>
            <InfoText
              title={"Date"}
              size="sm"
              value={
                timesheetDataFromDb?.period?.from &&
                timesheetDataFromDb?.period?.to
                  ? `${exactUTCDate(
                      timesheetDataFromDb?.period?.from,
                    )} - ${exactUTCDate(timesheetDataFromDb?.period?.to)}`
                  : "-"
              }
            />
          </div>
          <div>
            {/* //skipped for now */}
            <InfoTextTwo
              title="Attachment*"
              size="sm"
              value={{
                value: (
                  <div className="flex items-center gap-1">
                    {/* <a
                      className="leading-none"
                      href="/downloads/Shu-001-7368849.docx"
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                    > */}
                    {/* Shu-001-7368849.docx */}
                    {/* {timesheetDataFromDb?.employeeId} */}
                    <p>View</p>
                    {/* </a> */}
                    <Button
                      // type="link"
                      size="sm"
                      variant="text"
                      icon="visibility"
                      // color="black"
                      onClick={() => {
                        setIsModalOpen(true);
                        setSelectedDocuments(
                          timesheetDataFromDb?.attachments?.map(
                            (file, index) => ({
                              id: file.id,
                              filePath: file,
                              name: `Timesheet Attachment ${index + 1}`,
                            }),
                          ),
                        );
                      }}
                    />
                    {/* <p>Upload</p> */}
                    <Button
                      // type="link"
                      title={"Upload"}
                      size="sm"
                      variant="text"
                      iconPosition="after"
                      icon="upload"
                      onClick={() => {
                        setIsUploadOpen(true);
                      }}
                      disabled={![1, 2].includes(timesheetDataFromDb?.status)}
                    />
                  </div>
                ),
              }}
            />
          </div>
          <div className="flex gap-10">
            <InfoText
              size="sm"
              title={"Comments"}
              value={timesheetDataFromDb?.comments || "--"}
            />
            <Button
              title={"View Details"}
              size="sm"
              onClick={() => setClientDetails(true)}
            />
          </div>
        </div>
      </div>
      <div className="">
        {currentPlacementData?.uiid && timesheetId && (
          <TimeSheet
            isEditable={isEditable}
            setIsEditable={setIsEditable}
            currentPlacementData={currentPlacementData}
            // placementId={placementId}
            hasInvoice={hasInvoice}
            placementId={currentPlacementData?.uiid}
            timesheetId={timesheetId}
            startDate={timesheetDataFromDb?.period?.from}
            exposeState={handleExposeState}
          />
        )}
      </div>
      <Drawer
        isOpen={clientDetails}
        onClose={() => setClientDetails(false)}
        position="right"
        width="w-[60%]"
        title="Placement Information"
        closeOnOutsideClick
      >
        <div>
          <div className="grid grid-cols-2 gap-y-6">
            {/* <InfoText title={"CLIENT"} size="sm" value={"ShubhaMinds, LLC"} /> */}
            <InfoText
              title={"CLIENT"}
              size="sm"
              value={
                currentPlacementData?.jobInfo?.billClient?.businessName || ""
              }
            />

            <InfoText
              size="sm"
              title={"END CLIENT"}
              // value={"ShubhaMinds, LLC"}
              value={
                `${currentPlacementData?.jobInfo?.billClient?.businessName}` ||
                ""
              }
            />
            {/* <InfoText title={"JOB START DATE"} size="sm" value={"09/28/2023"} /> */}
            <InfoText
              title={"JOB START DATE"}
              size="sm"
              value={
                dateFormator(
                  currentPlacementData?.jobInfo?.startDate,
                  "month-day-year",
                ) || "-"
              }
            />
            {/* <InfoText title={"JOB END DATE"} size="sm" value={"01/31/2025"} /> */}
            <InfoText
              title={"JOB END DATE"}
              size="sm"
              value={
                dateFormator(
                  currentPlacementData?.jobInfo?.endDate,
                  "month-day-year",
                ) || "-"
              }
            />
            {/* <InfoText title={"PROJECT"} size="sm" value={"--"} /> */}
            <InfoText
              title={"PROJECT"}
              size="sm"
              value={currentPlacementData?.clientPlacement?.project || "-"}
            />

            <InfoTextTwo
              title="APPROVER(S)"
              size="sm"
              value={
                // [
                // {
                //   before: (
                //     <Button
                //       type="icon"
                //       size="sm"
                //       variant="text"
                //       icon="arrow_forward"
                //       color="black"
                //     />
                //   ),
                //   value: "Hemalatha Medisetti",
                //   after: (
                //     <>
                //       <StatusTags tag="Approved" variant="text" icon />
                //     </>
                //   ),
                // },
                // {
                //   before: (
                //     <Button
                //       type="icon"
                //       size="sm"
                //       variant="text"
                //       icon="arrow_forward"
                //       color="black"
                //     />
                //   ),
                //   value: "Vikranth Desireddy",
                //   after: (
                //     <>
                //       <StatusTags tag="Approved" variant="text" icon />
                //     </>
                //   ),
                // },
                // ]
                approverWithStatus?.map((item) => ({
                  before: (
                    <Button
                      type="icon"
                      size="sm"
                      variant="text"
                      icon="arrow_forward"
                      color="black"
                    />
                  ),
                  // value: "Hemalatha Medisetti",
                  value: item.name || "-",
                  after: (
                    <>
                      {/* <StatusTags tag="Approved" variant="text" icon /> */}
                      <StatusTags tag={item.status} variant="text" icon />
                    </>
                  ),
                }))
              }
            />
          </div>
          <div className="mt-4">
            <p className="mb-2">Employee Information</p>
            <Divider />
            <div className="grid grid-cols-2 gap-y-6 mt-6">
              <InfoText
                title={"EMPLOYEE NAME"}
                size="sm"
                // value={"Ramesh Manthri"}
                value={
                  [
                    currentPlacementData?.employeeId?.firstName,
                    currentPlacementData?.employeeId?.lastName,
                  ]
                    .filter(Boolean)
                    .join(" ") || ""
                }
              />
              {/* <InfoText
                title={"EMPLOYEE ID"}
                size="sm"
                // value={"CON - 2064"}
                value={
                  (currentPlacementData?.employeeId?.uiid &&
                    getEmployeeId(
                      currentPlacementData?.employeeId?.uiid,
                      currentPlacementData?.employeeId?.employmentType
                    )) ||
                  ""
                }
              /> */}
              <InfoText
                title={"EMPLOYEE ID"}
                size="sm"
                // value={"CON - 2064"}
                value={
                  (currentPlacementData?.employeeId?.uiid && employeeId) || ""
                }
              />
              <InfoText
                title={"EMAIL ID"}
                size="sm"
                // value={"rameshmanthri432@gmail.com"}
                value={currentPlacementData?.employeeId?.email.primary || ""}
              />
              <InfoText title={"DEPARTMENT"} size="sm" value={"Consulting"} />
              {/* <InfoText title={"ROLE"} size="sm" value={"Employee"} /> */}
              <InfoText
                title={"ROLE"}
                size="sm"
                value={
                  currentPlacementData?.employeeId?.employmentType
                    ? ["Regular", "Permanent", "Contractor"][
                        currentPlacementData?.employeeId?.employmentType - 1
                      ]
                    : ""
                }
              />
              <InfoText title={"REPORTING MANAGER"} size="sm" value={"--"} />
              {/* <InfoText title={"FINANCE MANAGER"} size="sm" value={employeeManagers.finance || "--"} /> */}
              <InfoText
                title={"FINANCE MANAGER"}
                size="sm"
                value={employeeManagers.finance || "-"}
              />
              <InfoText
                title={"HR MANAGER"}
                size="sm"
                value={employeeManagers.hr || "-"}
              />
            </div>
          </div>
        </div>
      </Drawer>
      <Modal
        isOpen={sendMailModal}
        onClose={() => setSendMailModal(false)}
        title="EMAIL  HISTORY"
        width="max-w-7xl"
      >
        <div>
          <div className="">
            <div className="grid grid-cols-2 gap-y-8">
              <InfoText title={"Timesheet Number"} value={"TS20250238"} />
              <InfoText title={"Client Name"} value={"ShubhaMinds, LLC"} />
              <InfoText title={"Job"} value={"Siebel Lead Developer|Shu-001"} />
              <InfoText title={"Employee Name"} value={"Ramesh Manthri"} />
            </div>
            <div className="mt-6">
              <TableAdv
                tableId={`employee_timesheet_timesheetdetails`}
                rows={emailRows}
                columns={emailcolumns}
                // toolbarRight={[{ hideToolbar: true }]}
              />
            </div>
            <div className="flex justify-end mt-10">
              <Button
                title={"Cancel"}
                variant="outlined"
                onClick={() => setSendMailModal(false)}
              />
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        width="max-w-2xl"
        title={"Document Details"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <>
          {selectedDocuments?.length > 0 ? (
            <DocumentsList data={selectedDocuments} />
          ) : (
            "No Attachments Found."
          )}
        </>
      </Modal>
      <Modal
        width="max-w-xl"
        title={"Upload Timesheet Documents"}
        isOpen={isUploadOpen}
        onClose={() => {
          handleChange("attachments", []);
          setIsUploadOpen(false);
        }}
        closeOnOutsideClick={true}
      >
        <>
          <div>
            <div className="m-2 flex-col gap-2">
              <FormFieldSet
                type="file"
                title="Attachment"
                placeholder="ChooseFile"
                value={formData.attachments}
                onChange={(value) => handleChange("attachments", value)}
                error={errors.attachments}
                multiple
                // disabled={timesheetDataFromDb?.uiid ? true : false}
              />
            </div>
            <div className="flex gap-2 m-2 justify-end">
              <Button
                size="md"
                variant="outlined"
                title={"Cancel"}
                onClick={() => {
                  handleChange("attachments", []);
                  setIsUploadOpen(false);
                }}
              />
              <Button
                size="md"
                variant="contained"
                title={"Upload"}
                onClick={handleUpload}
              />
            </div>
          </div>
        </>
      </Modal>
      <Modal
        isOpen={!allowEditing}
        title={"Confirmation"}
        onClose={() => setAllowEditing(true)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-xl"
      >
        <div className="flex flex-col items-center gap-4">
          <p className="text-sm text-neutrals-900">
            Editing this timesheet will overwrite the existing invoice's (
            {timesheetDataFromDb?.invoiceId
              ?.map((item) => item.invoiceNum)
              .join(", ")}
            )
          </p>
          <div className="flex justify-center gap-2 mt-4">
            <Button
              title={"Cancel"}
              variant="text"
              color="black"
              onClick={() => setAllowEditing(true)}
              className="w-full md:w-auto"
            />
            <Button
              title={"Confirm"}
              color="danger"
              variant="outlined"
              // disabled={true}
              onClick={() => {
                setEditConfirmation(true);
                setAllowEditing(true);
                setIsEditable((prev) => !prev);
              }}
              className="w-full md:w-auto"
            />
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={auditHistory}
        // title={"Confirmation"}
        onClose={() => setAuditHistory(false)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-7xl"
      >
        <div>
          <AuditHistory
            data={timesheetDataFromDb}
            placementData={currentPlacementData}
            approverWithStatus={approverWithStatus}
          />
        </div>
      </Modal>
      <Backdrop isOpen={isUploading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default TimesheetDetails;
